import allStatsForGame from "./allStatsForGame"

const allStats = () => {
    let toRet = {
        games:0,
        gamesLeague:{//solo durante la liga regular
            gAsSeeker:0,
            gAsKeeper:0,
            gAsChaser:0,
            gAsBeater:0,
        },
        gAsSeeker:0, //partidos totales, para entrenos
        gAsKeeper:0,
        gAsChaser:0,
        gAsBeater:0,
        expulsions:0,
    }

    Object.assign(toRet, allStatsForGame())

    return toRet;
}

export default allStats